module.exports = __webpack_public_path__ + "img/step2.6a171c49.webp";